import Vue from "vue"
import axios from "axios"

axios.defaults.timeout = 5000
axios.defaults.baseURL = process.env.VUE_APP_API_BASE || "https://subweb.ligangs2025.top"

Vue.prototype.$axios = axios
